import React, { Component } from "react";
import { connect } from "react-redux";
import { func } from "prop-types";
import { actions as adheredServicesActions } from "reducers/adheredServices";
import { Field, Form, withFormik } from "formik";
import { compose } from "redux";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";
import { push } from "connected-react-router";

const FORM_ID = "adheredServices";

class EditReference extends Component {
    static propTypes = {
        handleSubmit: func.isRequired,
    };

    render() {
        const { handleSubmit, isDesktop } = this.props;
        return (
            <div className={`container ${!isDesktop && "adhered-service-edit-draw"}`} style={{ maxWidth: "400px" }}>
                <I18n id="adheredService.edit.reference" component="h2" />
                <Form
                    className="above-the-fold"
                    onSubmit={(e) => {
                        handleSubmit(e);
                        e.stopPropagation();
                    }}>
                    <Field
                        component={TextField}
                        name="value"
                        type="text"
                        hidePlaceholder
                        idForm={FORM_ID}
                        labelText="payments.service.serviceReference.label"
                        maxLength="500"
                    />
                    <Button type="submit" className="btn-primary" label="global.save" />
                </Form>
            </div>
        );
    }
}

export default compose(
    connect(),
    withFormik({
        mapPropsToValues: () => ({ value: "" }),
        validationSchema: () =>
            Yup.object().shape({
                value: Yup.string().required(i18n.get("global.error.required")),
            }),
        handleSubmit: (values, formikBag) => {
            const { dispatch, service, setDrawer } = formikBag.props;
            setDrawer({
                showDrawer: false,
                contentDrawer: null,
            });
            dispatch(
                adheredServicesActions.adheredServicesRenameReducer({
                    serviceId: service?.serviceId,
                    operation: "replace",
                    path: "/alias",
                    value: values.value,
                }),
            );
            dispatch(push("/adheredServices/list"));
        },
    }),
)(EditReference);
